import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { ComercialModule } from "./ComercialModule";
import { ComercialDashboardAdmin } from "./ComercialDashboardAdmin";
import { ComercialConfig } from "./ComercialConfig";

export const ComercialAdmin = ({ onCreateQuotation, onViewQuotation, defaultTab }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [tab, setTab] = useState(defaultTab || (isAdmin ? "dashboard" : "contacts"));

  return (
    <div>
      <div className="flex gap-1 mb-6 bg-slate-100 p-1 rounded-lg w-fit" data-testid="comercial-admin-tabs">
        {isAdmin && (
          <button onClick={() => setTab("dashboard")}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "dashboard" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
            data-testid="comercial-tab-dashboard">
            Dashboard
          </button>
        )}
        <button onClick={() => setTab("contacts")}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "contacts" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
          data-testid="comercial-tab-contacts">
          Contactos
        </button>
        {isAdmin && (
          <button onClick={() => setTab("config")}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${tab === "config" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
            data-testid="comercial-tab-config">
            Configuracion
          </button>
        )}
      </div>
      {tab === "dashboard" && isAdmin && <ComercialDashboardAdmin />}
      {tab === "contacts" && <ComercialModule onCreateQuotation={onCreateQuotation} onViewQuotation={onViewQuotation} />}
      {tab === "config" && isAdmin && <ComercialConfig onBack={() => setTab("contacts")} />}
    </div>
  );
};
